<script>
import { authComputed } from "/src/store/helpers";
export default {
  computed: {
    ...authComputed,
  },
  name: "NavAdminControls",

  data() {
    return {
      slotName: "",
    };
  },

  methods: {
    preferredOption(name) {
      this.slotName = name;
      this.$emit("preferred-option", this.slotName);
    },
  },
};
</script>

<template>
  <div class="nav-admin-controls">
    <button class="button" @click="preferredOption('Tracer')">Tracer</button>
    <button class="button" @click="preferredOption('Paragraphs')">Paragraphs</button>
  </div>
</template>

<style scoped lang="less"></style>
